<template lang="pug">
    .component-simple-columns3-3
        .row
            .columns.n1.small-4
                slot(name="n1")
            .columns.n2.small-4
                slot(name="n2")
            .columns.n3.small-4
                slot(name="n3")
        .row
            .columns.n4.small-4
                slot(name="n4")
            .columns.n5.small-4
                slot(name="n5")
            .columns.n6.small-4
                slot(name="n6")

</template>
<script type="text/babel">
    export default {
        name: "simpleColumns3-3",
        components: {},
        data() {
            return {}
        },
        created() {
        },
        methods: {
            actionClicked() {
                this.$emit('actionClicked')
            },
            bulletsClicked() {
                this.$emit('bulletsClicked')
            }
        },
        computed: {},
        props: ['showBullets', 'showAction']
    }
</script>

<style lang="sass" rel="stylesheet/sass">
    .action
        cursor: pointer
</style>


// WEBPACK FOOTER //
// simpleColums3-3.vue?3ce69f9a